import React from 'react'
import { HiOutlineX } from "react-icons/hi";

const Todo = ({todo, index, deleteTodo}) => {
    
  return (
    <li className="list-none ">
        <div className="flex items-center justify-between bg-white py-2 px-4 mb-2 rounded-sm">
            <p className="text-blue-500 font-semibold">{todo}</p>
            <div className="flex gap-2">
                <HiOutlineX onClick={() => deleteTodo(index) } className='bg-blue-500 rounded-full text-white w-5 h-5 p-1 cursor-pointer'/>
            </div>
        </div>
    </li>
  )
}

export default Todo